import { DeleteModalService } from './../../services/delete-modal.service';
import { DeleteModalComponent } from './../../../shared/delete-modal/delete-modal.component';
import { LocationsModalComponent } from './../../../shared/locations-modal/locations-modal.component';
import { MasterService } from './../../services/master.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss']
})
export class LocationsComponent implements OnInit {

  public locations: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By City Name';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;

  constructor(public masterservice: MasterService, public dialog: MatDialog, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.cities.view'] == 1 || roles['more.cities.add'] == 1 || roles['more.cities.edit'] == 1 || roles['more.cities.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.cities.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.cities.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.cities.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getLocationsData();
  }

  getLocationsData() {

    // let page = e;
    this.masterservice.getIndex('/locations/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.locations = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page      = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;
      const newData = {
       region_name: '',
       country_name: '',
       name: ''
     };
      if (this.locations.length < this.per_page) {
        for ( let i = 0; i < this.itemToBePushed ; i++) {
          this.locations.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });

  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By City Name';
          break;
        case '1':
          this.placeHolder = 'Search By Region Name';
          break;
        case '2':
          this.placeHolder = 'Search by Country Name';
          break;
        default: this.placeHolder = 'Search By City Name';
      }
    }
  }

  openDialog(): void {
      const dialogRef = this.dialog.open(LocationsModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true
    }).afterClosed().subscribe(() => this.getLocationsData());
  }


  editDialog(i) {
    const editId = this.locations[i].id;
    const encID = this.locations[i].enc_id;
    // tslint:disable-next-line:triple-equals
    if ( editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(LocationsModalComponent, {
        minWidth: '40vw',
        minHeight: '20vh',
        disableClose: true,
        data: {
          edit: {
            editID: editId,
            encryId: encID
          }
        }
      }).afterClosed().subscribe(() => this.getLocationsData());
    }
  }

  doSearch(): void {
  if (this.searchBy != null) {
      switch (this.searchBy) {
         case '0':
           Object.assign(this.filter, {search: { type: 'str', field: 'locations.name', text: this.searchTxt}});
           break;
        case '1':
          Object.assign(this.filter, {search: { type: 'str', field: 'regions.name', text: this.searchTxt}});
          break;
        case '2':
          Object.assign(this.filter, {search: { type: 'str', field: 'countries.name', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: { type: 'str', field: 'locations.name', text: this.searchTxt}});
      }
    }
  this.getLocationsData();
  }

   doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getLocationsData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getLocationsData();
  }

  deleteDialog(i): void {
    this.deleteModalService.openModal({
      token: localStorage.getItem('token'),
      id: this.locations[i].id,
      encId: this.locations[i].enc_id,
      deleteUrl: '/locations/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getLocationsData();
    });
  }
}

